export default function additionalcalledcostitemtypes(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
        return {
            ...state,
            additionalcalledcostitemtype: action.additionalcalledcostitemtype,
        }
    case 'ADD_CURRENT_ORGANIZATION':
        return {
            ...state,
            additionalcalledcostitemtype: action.additionalcalledcostitemtype,
            organization: action.organization,
        }
      default:
          return state;
  }
}